import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Arcane Power",
    "spell_nature_lightning",
    [
      "When activated, your spells deal 30% more damage while costing 30% more mana to cast. This effect lasts 15 sec.",
    ],
    1,
    [[]],
    [{ x: 5, y: 1 }],
    null,
    null,
    null,
    "Instant",
    "3 min cooldown",
  ),
];

export default tier7;
